export default __webpack_public_path__ + "static/media/sec3.cf1523e1.jpeg";